export default {
  dynamics: '{{change}} par rapport à la {{time_unit}} précédente',
};
